import './audienceWidget.scss'
import { useEffect } from 'react'
import { AnalyticsSelectors, AudienceTable } from '@/features/analytics'
import { useInviteLinksStore } from '@/features/analytics/model'
import { useInviteLinksTimeSelectors } from '@/features/analytics/invite-links/hooks'
import clsx from 'clsx'
import { Pagination } from '@/shared/ui/pagination'
import { Channel } from '@/true-fsd/data/advertiser-account'

export type AudienceWidgetProps = {
    activeChannel: Channel
}
export const AudienceWidget = ({ activeChannel }: AudienceWidgetProps) => {
    const {
        startDateAudience,
        endDateAudience,
        usersSortAudience,
        subscriberStatusSortAudience,
        trafficSourceSortAudience,
        detalizationSortAudience,
        lineDateAudience,
        setLineDateAudience,
        setStartDateAudience,
        setEndDateAudience,
        calculateStartEndDateAudience,
        setTrafficSourceSortAudience,
        setDetalizationSortAudience,
        setUsersSortAudience,
        setSubscriberStatusSortAudience,
        fetchAudienceByChannel,
        audienceByChannel,
        currentPageAudience,
        totalPagesAudience,
    } = useInviteLinksStore()

    // const { data: audienceData } = useAudienceData(
    //     activeWorkspace?.channel_id ?? 0,
    //     activeWorkspace?.created_at ?? new Date()
    //   );

    const { handleLineDateSelect, handleDateChange } =
        useInviteLinksTimeSelectors({
            setLineDate: setLineDateAudience,
            setStartDate: setStartDateAudience,
            setEndDate: setEndDateAudience,
        })

    // Fetch audience data when the active channel changes
    useEffect(() => {
        const defaultPage = currentPageAudience[activeChannel.channel_id] || 1
        fetchAudienceByChannel(
            activeChannel.channel_id,
            activeChannel.created_at,
            defaultPage,
            200
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handlePageChange = (newPage: number) => {
        fetchAudienceByChannel(
            activeChannel.channel_id,
            activeChannel.created_at,
            newPage,
            200
        )
    }

    useEffect(() => {
        if (!startDateAudience || !endDateAudience) {
            const { startDate, endDate } = calculateStartEndDateAudience(
                activeChannel.channel_id
            )
            setStartDateAudience(startDate)
            setEndDateAudience(endDate)
        }
    }, [
        activeChannel,
        startDateAudience,
        endDateAudience,
        calculateStartEndDateAudience,
        setStartDateAudience,
        setEndDateAudience,
    ])

    // if (isLoading) {
    //     return <>
    //         {isLoading && (
    //             <div className="loading-overlay">
    //                 <LoadingIndicator style={{ width: '80px', height: '80px'}} />
    //             </div>
    //         )}
    //     </>
    // }

    const audienceData = audienceByChannel[activeChannel.channel_id]
    const totalItems = audienceData?.length || 1
    return (
        <div className="audience-widget">
            <h3 className={clsx('title', 'audience-widget__title')}>
                Аудитория
            </h3>
            <AnalyticsSelectors
                lineDate={lineDateAudience}
                trafficSource={trafficSourceSortAudience}
                detalization={detalizationSortAudience}
                users={usersSortAudience}
                subscribers={subscriberStatusSortAudience}
                datePicker={{
                    startDate: startDateAudience,
                    endDate: endDateAudience,
                }}
                onLineDateSelect={handleLineDateSelect}
                onTrafficSourceSelect={setTrafficSourceSortAudience}
                onDetalizationSelect={setDetalizationSortAudience}
                onUsersSelect={setUsersSortAudience}
                onSubscribersSelect={setSubscriberStatusSortAudience}
                onDateChange={{
                    onFromDateChange: (date) =>
                        handleDateChange(date, endDateAudience),
                    onToDateChange: (date) =>
                        handleDateChange(startDateAudience, date),
                }}
                mode="Audience"
            />

            <AudienceTable
                activeChannel={activeChannel}
                data={audienceData ?? []}
            />
            {totalItems > 0 &&
                totalPagesAudience[activeChannel.channel_id] > 1 && (
                    <Pagination
                        currentPage={
                            currentPageAudience[activeChannel.channel_id]
                        }
                        totalPages={
                            totalPagesAudience[activeChannel.channel_id]
                        }
                        onPageChange={handlePageChange}
                        totalItems={totalItems}
                    />
                )}
        </div>
    )
}
